import get from "lodash/get";
import { defaultObject } from "redux-store";
import { createSelector } from "reselect";

function strategiesSelector(state) {
  return get(state, "app.strategies.byId", defaultObject);
}

function _byIdSelector(byId) {
  return byId;
}

function _archiveStatusSelector(_byId, archiveStatus) {
  return archiveStatus;
}

function _getArchivedStrategies(byId, archiveStatus) {
  return Object.keys(byId).reduce((acc, id) => {
    const strategy = byId[id];
    if (Boolean(strategy.archived) === archiveStatus) {
      acc[id] = strategy;
    }

    return acc;
  }, {});
}

const getStrategiesByArchiveStatus = createSelector(
  _byIdSelector,
  _archiveStatusSelector,
  _getArchivedStrategies,
);

export { strategiesSelector, getStrategiesByArchiveStatus };
